import React from 'react';
import {Trans} from 'react-i18next';
import {Entry, TimelineEntryWithUpdates} from './Shared';

export const ExtraWorkEntryUpdatedTimelineEntry = ({entry}) => {
    return (
        <TimelineEntryWithUpdates entry={entry} status="change" icon="work">
            <Entry.Title>
                <Trans
                    i18nKey="warehousing.timeline.ExtraWorkEntryUpdated.title"
                    values={{extraWorkItem: entry.extraWorkItemDescription}}
                />
            </Entry.Title>
        </TimelineEntryWithUpdates>
    );
};
